"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = shouldDisableTracking;
const constants_1 = require("./constants");
const cookies_1 = require("./cookies");
function shouldDisableTracking(isLocalEnv) {
    return isLocalEnv || !!(0, cookies_1.getCookie)(constants_1.COOKIE_E2E);
}
//# sourceMappingURL=shouldDisableTracking.js.map